import { Action } from '../actions'
import { ConsentBannerAction } from '../constants'

export function showConsentBanner(currentShowConsentBanner: boolean = true, action: Action): boolean {
  switch (action.type) {
    case ConsentBannerAction.HIDE_CONSENT_BANNER:
      return false
    default:
      return currentShowConsentBanner
  }
}
